import React, { useState, useMemo } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import styles from './CompetitorMap.module.scss'
import { MapMarkers } from './components/map-markers'
import { MapLegend } from './components/map-legend'
import { NearbyStationsLayer } from './components/nearby-stations-layer'
import { VectorBasemap } from './components/vector-basemap'
import { MapContainer, AttributionControl } from 'react-leaflet'
import { useFlags } from 'launchdarkly-react-client-sdk'

const cx = classNames.bind(styles)

const CompetitorMap = ({ station, selectedFuelGrade }) => {
  const { showNearbyStationCompetitors } = useFlags()
  const [legendView, setLegendView] = useState('open')

  const competitorIds = useMemo(
    () => new Set(station.competitors.map((c) => c.id)),
    [station.competitors]
  )

  const fuelGrades = useMemo(
    () =>
      station.fuelGrades.map(({ fuelGrade }) => ({
        id: fuelGrade.id,
        shortTitle: fuelGrade.shortTitle,
      })),
    [station.fuelGrades]
  )

  return (
    <MapContainer
      attributionControl={false}
      className={cx('map')}
      center={[station.latitude, station.longitude]}
      zoom={13}
      minZoom={4}
      maxZoom={16}
      scrollWheelZoom={false}
    >
      <VectorBasemap />
      <AttributionControl prefix="&copy; <a target='_BLANK' href='https://openfreemap.org/'>OpenFreeMap</a> &copy; <a target='_BLANK' href='https://www.openmaptiles.org/'>OpenMapTiles</a> Data &copy; <a target='_BLANK' href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors" />
      {showNearbyStationCompetitors && (
        <NearbyStationsLayer
          stationId={station.id}
          competitorIds={competitorIds}
          fuelGrades={fuelGrades}
        />
      )}
      <MapMarkers
        station={station}
        selectedFuelGrade={selectedFuelGrade}
        stationId={station.id}
        showNearbyStationCompetitors={showNearbyStationCompetitors}
      />
      <MapLegend legendView={legendView} onToggle={setLegendView} showNearbyStationCompetitors={showNearbyStationCompetitors} />
    </MapContainer>
  )
}

CompetitorMap.propTypes = {
  station: PropTypes.shape().isRequired,
  selectedFuelGrade: PropTypes.string.isRequired,
}

export { CompetitorMap }
